const IconHeartFilled = (props) => {
  return (
    <svg
      width='20'
      height='19'
      viewBox='0 0 20 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M1.54325 2.41953C2.57267 1.3847 3.92196 0.863281 5.27389 0.863281C6.62598 0.863281 7.98221 1.38465 9.0117 2.41948L10.0066 3.42143L10.9872 2.42658C13.0463 0.356918 16.3968 0.356918 18.4558 2.42658C20.5147 4.49633 20.5147 7.85391 18.4558 9.92357C15.7961 12.5964 13.1349 15.2665 10.4756 17.9393C10.3476 18.0672 10.1744 18.14 9.99234 18.14C9.81113 18.14 9.63792 18.0672 9.50912 17.9393L1.54325 9.90948C-0.513086 7.83881 -0.515746 4.48919 1.54325 2.41953Z'
        fill='#F92044'
      />
    </svg>
  )
}

export default IconHeartFilled
